const rollPerGlue3m = 16;
const rollPerGlue10m = 4;

export function calculate(wallWidth, wallHeight, productWidth, productHeight, unit, conversion)
{

    let rolls = getRollQuantity(wallWidth, wallHeight, productWidth, productHeight, unit, conversion);
    let glue = getGlueQuantity(rolls, productHeight);

    return {'rolls': rolls, 'glue': glue};
}

export function getRollQuantity(wallWidth, wallHeight, productWidth, productHeight, unit, conversionFactor)
{
    unit = unit || 'cm';
    conversionFactor = Number(conversionFactor) || 1;

    if (unit === 'in') {
        wallWidth = Number(wallWidth) * conversionFactor;
        wallWidth = Math.floor(wallWidth.toFixed(2));
        wallHeight = Number(wallHeight) * Number(conversionFactor);
        wallHeight = wallHeight.toFixed(2);
    }

    let width = Number(wallWidth)/Number(productWidth);
    let height = Number(wallHeight)/Number(productHeight);

    if (Number(productHeight) < 1000) {
        height = Math.ceil(height);
    }

    return Math.ceil(width * height);
}

export function getGlueQuantity(numberOfRolls, productHeight)
{
    let rollPerGlue = rollPerGlue3m;
    switch (productHeight) {
        case '1000':
            rollPerGlue = rollPerGlue10m;
            break;
        case '300':
            rollPerGlue = rollPerGlue3m;
            break;
    }

    return Math.ceil(Number(numberOfRolls) / rollPerGlue);
}